import { Resource } from './resource';

export class Technology extends Resource {
    value: String;
    name : String;
    label : String;
    id: String
  }